(function () {
  'use strict';

  angular.module('app').component('passwordRecoveryEditPage', PasswordRecoveryEditPage());

  function PasswordRecoveryEditPage() {
    return {
      bindings: {},
      controller: PasswordRecoveryEditPageCtrl,
      controllerAs: 'vm',
      templateUrl: './app/ajs/_pages/password-recovery-edit/password-recovery-edit-page.html',
    };
  }

  function PasswordRecoveryEditPageCtrl() {}
})();
